import React, { useState, useEffect } from 'react';
import apiClient from '../../utils/api';
import { handleApiError } from '../../utils/errorHandler';
import { useTranslation } from '../../i18n';

const PreferencesTab = () => {
  const { t } = useTranslation();
  const [preferences, setPreferences] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    loadPreferences();
  }, []);

  const loadPreferences = async () => {
    try {
      const response = await apiClient.get('/user/preferences');
      setPreferences(response.data.preferences || {});
    } catch (err) {
      console.error('Error loading preferences:', err);
      setError(handleApiError(err, 'Failed to load preferences', t));
    }
  };

  const handleChange = (key, value) => {
    setPreferences(prev => ({ ...prev, [key]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    setSuccess('');
    setError('');

    try {
      await apiClient.post('/user/preferences', { preferences });
      setSuccess('Preferences saved successfully!');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      console.error('Error saving preferences:', err);
      setError(handleApiError(err, 'Failed to save preferences', t));
    } finally {
      setLoading(false);
    }
  };

  const formatLabel = (key) => {
    return key
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <div className="tab-content">
      <div className="tab-header">
        <h2>{t('userPreferences')}</h2>
        <p>{t('customizeExperience')}</p>
      </div>

      {success && <div className="alert alert-success">{success}</div>}
      {error && <div className="alert alert-error">{error}</div>}

      <div className="preferences-section">
        {Object.keys(preferences).length === 0 ? (
          <p style={{ color: '#666', textAlign: 'center', padding: '2rem' }}>
            {t('noPreferencesYet')}
          </p>
        ) : (
          Object.entries(preferences).map(([key, value]) => (
            <div key={key} className="form-group">
              <label>{formatLabel(key)}</label>
              <input
                type="text"
                value={value || ''}
                onChange={(e) => handleChange(key, e.target.value)}
                placeholder={`${t('enter')} ${formatLabel(key).toLowerCase()}`}
              />
            </div>
          ))
        )}

        <button
          className="btn btn-primary"
          onClick={handleSave}
          disabled={loading}
          style={{ marginTop: '1.5rem' }}
        >
          {loading ? t('saving') : t('savePreferences')}
        </button>
      </div>
    </div>
  );
};

export default PreferencesTab;
